import device from './device'
import kuisioner from './kuisioner'
import listTalent from './list-talent'
import requestEdit from './request-edit'
import reportPerformance from './report-performance'

export default [...device, ...kuisioner, ...listTalent, ...requestEdit, ...reportPerformance]
